function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute('role', 'button'),
    e.setAttribute('aria-expanded', 'false'),
    e.nextElementSibling.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id),
    e.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
    }),
    e.closest('header-drawer') || e.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== n && t.target !== s) ||
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      'TAB' === t.code.toUpperCase() &&
        (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()),
        (t.target !== e && t.target !== s) || !t.shiftKey || (t.preventDefault(), n.focus()));
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    t.focus();
}
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const e = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let t = null,
    i = null;
  window.addEventListener('keydown', (t) => {
    e.includes(t.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener('mousedown', (e) => {
      i = !0;
    }),
    window.addEventListener(
      'focus',
      () => {
        t && t.classList.remove('focused'), i || ((t = document.activeElement), t.classList.add('focused'));
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }),
    document.querySelectorAll('.js-vimeo').forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', '*');
    }),
    document.querySelectorAll('video').forEach((e) => e.pause()),
    document.querySelectorAll('product-model').forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}

const MOBILE_VIEWPORT_BREAKPOINT = 767;
const isMobileViewport = () => window.matchMedia(`(max-width: ${MOBILE_VIEWPORT_BREAKPOINT}px)`).matches;

function setAddToCartButtonLabel(button) {
  if (!button) return;
  const labelSpan = button.querySelector('span:not(.totalPriceOnButton)');
  if (!labelSpan) return;

  const { labelMobile, labelDesktop } = button.dataset;
  if (!labelMobile && !labelDesktop) return;

  const selectedLabel = isMobileViewport() ? labelMobile || labelDesktop : labelDesktop || labelMobile;

  if (selectedLabel) {
    labelSpan.textContent = selectedLabel;
  }
}

function updateResponsiveAddToCartLabels() {
  document
    .querySelectorAll('button[name="add"][data-label-mobile], button[name="add"][data-label-desktop]')
    .forEach(setAddToCartButtonLabel);
}

window.updateResponsiveAddToCartLabels = updateResponsiveAddToCartLabels;

updateResponsiveAddToCartLabels();

let responsiveAddToCartResizeTimeout;
window.addEventListener('resize', () => {
  if (responsiveAddToCartResizeTimeout) {
    clearTimeout(responsiveAddToCartResizeTimeout);
  }
  responsiveAddToCartResizeTimeout = setTimeout(updateResponsiveAddToCartLabels, 150);
});

const LOWEST_PRICE_WRAPPER_SELECTOR = '[data-lowest-price-wrapper]';
const LOWEST_PRICE_ELEMENT_SELECTOR = '.lowest-price-element';
let lowestPriceEventsBound = false;

function updateLowestPriceElementContent(priceElement) {
  if (!priceElement) return;
  const rawPrice = (priceElement.dataset.originalPrice || '').trim().replace(',', '.');
  const price = parseFloat(rawPrice);
  const multiplier = parseFloat(priceElement.dataset.subDiscount || '1');

  if (!Number.isFinite(price) || !Number.isFinite(multiplier)) return;

  const finalPrice = (price * multiplier).toFixed(2).replace('.', ',') + 'zł';
  const lowestPriceValue = priceElement.querySelector('.lowest-price');
  if (lowestPriceValue) {
    lowestPriceValue.textContent = finalPrice;
  }

  const wordingElement = priceElement.querySelector('.lowest-wording');
  if (wordingElement) {
    wordingElement.textContent = multiplier === 1 ? 'jednorazowym' : 'subskrypcyjnym';
  }
}

function showLowestPriceForVariantInWrapper(wrapper, variantId) {
  const priceElements = wrapper.querySelectorAll(LOWEST_PRICE_ELEMENT_SELECTOR);
  if (!priceElements.length) return;

  let matchFound = false;

  priceElements.forEach((priceElement) => {
    const elementVariantId = Number(priceElement.dataset.variantId);
    if (variantId && elementVariantId === Number(variantId)) {
      priceElement.classList.remove('hidden');
      updateLowestPriceElementContent(priceElement);
      matchFound = true;
    } else {
      priceElement.classList.add('hidden');
    }
  });

  if (!matchFound) {
    priceElements.forEach((priceElement) => priceElement.classList.add('hidden'));
  }
}

function handleLowestPriceVariantChange(event) {
  const variant = event?.detail?.currentVariant;
  if (!variant) return;

  const productId = variant.product_id || variant.productId;
  const selector = productId
    ? `${LOWEST_PRICE_WRAPPER_SELECTOR}[data-product-id="${productId}"]`
    : LOWEST_PRICE_WRAPPER_SELECTOR;

  document.querySelectorAll(selector).forEach((wrapper) => {
    showLowestPriceForVariantInWrapper(wrapper, variant.id);
  });
}

function handleLowestPriceSellingPlanChange(event) {
  const planType = event?.detail?.planType;
  if (!planType) return;

  const multiplier = planType === 'sub' ? 0.85 : 1;

  document.querySelectorAll(LOWEST_PRICE_WRAPPER_SELECTOR).forEach((wrapper) => {
    wrapper.querySelectorAll(LOWEST_PRICE_ELEMENT_SELECTOR).forEach((priceElement) => {
      priceElement.dataset.subDiscount = multiplier;
      if (!priceElement.classList.contains('hidden')) {
        updateLowestPriceElementContent(priceElement);
      }
    });
  });
}

function initializeLowestPriceFrom30Days(root = document) {
  if (!root) return;

  const wrappers =
    root === document
      ? document.querySelectorAll(LOWEST_PRICE_WRAPPER_SELECTOR)
      : root.querySelectorAll(LOWEST_PRICE_WRAPPER_SELECTOR);

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const initialVariantId = Number(wrapper.getAttribute('data-initial-variant-id'));
    if (initialVariantId) {
      showLowestPriceForVariantInWrapper(wrapper, initialVariantId);
    }
  });

  if (!lowestPriceEventsBound) {
    document.addEventListener('onVariantChange', handleLowestPriceVariantChange);
    document.addEventListener('onSellingPlanChange', handleLowestPriceSellingPlanChange);
    lowestPriceEventsBound = true;
  }
}

window.initializeLowestPriceFrom30Days = initializeLowestPriceFrom30Days;

document.addEventListener('DOMContentLoaded', () => {
  updateResponsiveAddToCartLabels();
  initializeLowestPriceFrom30Days(document);
});

function removeTrapFocus(e = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ('ESCAPE' !== e.code.toUpperCase()) return;
  const t = e.target.closest('details[open]');
  if (!t) return;
  const i = t.querySelector('summary');
  t.removeAttribute('open'), i.setAttribute('aria-expanded', !1), i.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', { bubbles: true })),
      this.querySelectorAll('button').forEach((e) => e.addEventListener('click', this.onButtonClick.bind(this)));
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = this.input.value;
    'plus' === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function fetchConfig(e = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${e}` },
  };
}
customElements.define('quantity-input', QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent('on' + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || 'post',
      s = t.parameters || {},
      n = document.createElement('form');
    for (var r in (n.setAttribute('method', i), n.setAttribute('action', e), s)) {
      var o = document.createElement('input');
      o.setAttribute('type', 'hidden'), o.setAttribute('name', r), o.setAttribute('value', s[r]), n.appendChild(o);
    }
    document.body.appendChild(n), n.submit(), document.body.removeChild(n);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute('data-default');
      e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute('data-provinces'),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = 'none';
      else {
        for (var s = 0; s < i.length; s++) {
          var n;
          ((n = document.createElement('option')).value = i[s][0]),
            (n.innerHTML = i[s][1]),
            this.provinceEl.appendChild(n);
        }
        this.provinceContainer.style.display = '';
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement('option');
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector('details')),
      'iPhone' === navigator.platform &&
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`),
      this.addEventListener('keyup', this.onKeyUp.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((e) => e.addEventListener('click', this.onSummaryClick.bind(this))),
      this.querySelectorAll('button').forEach((e) => e.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(e) {
    if ('ESCAPE' !== e.code.toUpperCase()) return;
    const t = e.target.closest('details[open]');
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    const t = e.currentTarget,
      i = t.parentNode,
      s = i.hasAttribute('open'),
      n = window.matchMedia('(prefers-reduced-motion: reduce)');
    function r() {
      trapFocus(t.nextElementSibling, i.querySelector('button')),
        t.nextElementSibling.removeEventListener('transitionend', r);
    }
    i === this.mainDetailsToggle
      ? (s && e.preventDefault(), s ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
      : setTimeout(() => {
          i.classList.add('menu-opening'),
            t.setAttribute('aria-expanded', !0),
            !n || n.matches ? r() : t.nextElementSibling.addEventListener('transitionend', r);
        }, 100);
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }),
      e.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove('menu-opening'),
      document.querySelector('.header__mobile-bars').classList.remove('opened'),
      this.mainDetailsToggle.querySelectorAll('details').forEach((e) => {
        e.removeAttribute('open'), e.classList.remove('menu-opening');
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(e) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest('details');
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    e.classList.remove('menu-opening'),
      e.querySelector('summary').setAttribute('aria-expanded', !1),
      removeTrapFocus(e.querySelector('summary')),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t;
    const i = (s) => {
      void 0 === t && (t = s);
      s - t < 400
        ? window.requestAnimationFrame(i)
        : (e.removeAttribute('open'),
          e.closest('details[open]') && trapFocus(e.closest('details[open]'), e.querySelector('summary')));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    (this.header = this.header || document.getElementById('shopify-section-header')),
      (this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      ),
      this.header.classList.add('menu-open'),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }),
      e.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t) {
    super.closeMenuDrawer(e, t), this.header.classList.remove('menu-open');
  }
}
customElements.define('header-drawer', HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this)),
      this.addEventListener('keyup', (e) => {
        'ESCAPE' === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains('media-modal')
        ? this.addEventListener('pointerup', (e) => {
            'mouse' !== e.pointerType || e.target.closest('deferred-media, product-model') || this.hide();
          })
        : this.addEventListener('click', (e) => {
            'MODAL-DIALOG' === e.target.nodeName && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    const t = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden'),
      this.setAttribute('open', ''),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden'),
      this.removeAttribute('open'),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('button');
    e &&
      e.addEventListener('click', () => {
        const t = document.querySelector(this.getAttribute('data-modal'));
        t && t.show(e);
      });
  }
}
customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute('loaded'))) {
      const t = document.createElement('div');
      t.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0)),
        this.setAttribute('loaded', !0);
      const i = this.appendChild(t.querySelector('video, model-viewer, iframe'));
      e && i.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector('.slider-counter--current')),
      (this.pageTotalElement = this.querySelector('.slider-counter--total')),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages();
    new ResizeObserver((e) => this.initPages()).observe(this.slider),
      this.slider.addEventListener('scroll', this.update.bind(this)),
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        )),
        (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
  }
  update() {
    const e = this.currentPage;
    (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute('disabled', 'disabled')
          : this.prevButton.removeAttribute('disabled'),
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
          ? this.nextButton.setAttribute('disabled', 'disabled')
          : this.nextButton.removeAttribute('disabled'));
  }
  isSlideVisible(e, t = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - t;
    return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = e.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      'next' === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderItemOffset
        : this.slider.scrollLeft - t * this.sliderItemOffset),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector('.slider-buttons')),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
        )),
        this.sliderControlLinksArray.forEach((e) => e.addEventListener('click', this.linkToSlide.bind(this))),
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this)),
        this.setSlideVisibility(),
        'true' === this.slider.getAttribute('data-autoplay') && this.setAutoPlay());
  }
  setAutoPlay() {
    (this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this)),
      this.addEventListener('mouseover', this.focusInHandling.bind(this)),
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this)),
      this.addEventListener('focusin', this.focusInHandling.bind(this)),
      this.addEventListener('focusout', this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(e) {
    super.onButtonClick(e);
    const t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    (t || i) &&
      (t && 'previous' === e.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
        : i && 'next' === e.currentTarget.name && (this.slideScrollPosition = 0),
      this.slider.scrollTo({ left: this.slideScrollPosition }));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
      this.prevButton.removeAttribute('disabled'),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((e) => {
          e.classList.remove('slider-counter__link--active'), e.removeAttribute('aria-current');
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(e) {
    const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
    this.autoplayButtonIsSetToPlay && !t && this.play();
  }
  focusInHandling(e) {
    (e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) &&
    this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute('aria-live', 'off'),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
  }
  pause() {
    this.slider.setAttribute('aria-live', 'polite'), clearInterval(this.autoplay);
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow))
      : (this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow));
  }
  autoRotateSlides() {
    const e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({ left: e });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((e, t) => {
      const i = e.querySelector('a');
      t === this.currentPage - 1
        ? (i && i.removeAttribute('tabindex'), e.setAttribute('aria-hidden', 'false'), e.removeAttribute('tabindex'))
        : (i && i.setAttribute('tabindex', '-1'),
          e.setAttribute('aria-hidden', 'true'),
          e.setAttribute('tabindex', '-1'));
    });
  }
  linkToSlide(e) {
    e.preventDefault();
    const t =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: t });
  }
}

// Toggler klaviyo form and recharge toggler
function loadKlaviyoSoldOutForm() {
  const addToCartWrapper = document.querySelector('.product__add-to-cart');
  const variantDescriptions = document.querySelectorAll('.variant__description');

  if (variantDescriptions) {
    for (let i = 0; i < variantDescriptions.length; i++) {
      const description = variantDescriptions[i];

      const showSoldOutButton = description.getAttribute('showSoldOutButton') === 'true';
      const isAvailable = description.getAttribute('data-is-available') === 'true';

      const formId = description.getAttribute('data-variant-klaviyo-form-id');

      const form = document.querySelector(`.klaviyo-form-${formId}`);
      const fakeButton = document.querySelector('.fake-soldout-button');

      //const subscriptionWidget = document.getElementById('yk-subscription-widget');

      if (description.style.display === 'block') {
        if (form) {
          form.style.display = 'block';
          addToCartWrapper.style.display = 'none';

          break;
        } else if ((!isAvailable || showSoldOutButton) && !fakeButton) {
          addToCartWrapper.insertAdjacentHTML(
            'beforebegin',
            '<button disabled class="btn btn--primary-2 fake-soldout-button w-full mt-5">WYPRZEDANY</button>'
          );

          // if (subscriptionWidget) {
          //   subscriptionWidget.style.display = 'none';
          // }

          addToCartWrapper.style.display = 'none';
          break;
        }
      } else {
        if (form) {
          form.style.display = 'none';
          addToCartWrapper.style.display = 'flex';
        }

        if (fakeButton) {
          fakeButton.style.display = 'none';
        }
      }
    }
  }
}
window.addEventListener('DOMContentLoaded', function () {
  loadKlaviyoSoldOutForm();
});

customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.quickBuyEnabled = this.dataset.quickBuy === 'true';
    this.addEventListener('change', () => {
      this.onVariantChange();
    });
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, ''),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateMedia(),
          this.dispatchChangeVariantEvent(),
          this.updateSelectedSwatchName(),
          this.updateURL(),
          this.updateVariantInput(this.currentVariant),
          this.handleOnetimesAddToCartButtonPriceChange(),
          this.handleCustomWidgetPriceChange(this.currentVariant),
          this.renderProductInfo(),
          this.updateShareUrl(),
          this.updateVariantDetails(this.currentVariant),
          this.updateFastBuyGallery(this.currentVariant))
        : (this.toggleAddButton(true, ''), this.setUnavailable());
  }

  dispatchChangeVariantEvent() {
    const event = new CustomEvent('onVariantChange', {
      detail: {
        currentVariant: this.currentVariant,
      },
    });
    document.dispatchEvent(event);
  }

  updateSelectedSwatchName() {
    const selectedSwatchName = this.querySelectorAll('.color-swatch-selected-value');
    if (selectedSwatchName && selectedSwatchName.length === 2) {
      selectedSwatchName[0].innerText = this.currentVariant.option1;
      selectedSwatchName[1].innerText = this.currentVariant.option2;
    } else if (selectedSwatchName && selectedSwatchName.length === 3) {
      selectedSwatchName[0].innerText = this.currentVariant.option1;
      selectedSwatchName[1].innerText = this.currentVariant.option2;
      selectedSwatchName[2].innerText = this.currentVariant.option3;
    } else if (selectedSwatchName.length) {
      selectedSwatchName[0].innerText = this.currentVariant.option1;
    }
  }

  // Udpade metafield variant by change variants start Blue Owl
  updateVariantDetails(currentVariant) {
    const variants = document.querySelectorAll('[data-variant-id]');
    const variantDescritpions = document.querySelectorAll('.variant__description');

    const fakeButton = document.querySelector('.fake-soldout-button');

    const addToCartWrapper = document.querySelector('.product__add-to-cart');

    variants.forEach(function (variant) {
      variant.style.display = 'none';
      if (variant.dataset.variantId == currentVariant.id) {
        variant.style.display = 'block';
      }
    });

    if (variantDescritpions) {
      for (let i = 0; i < variantDescritpions.length; i++) {
        const description = variantDescritpions[i];

        const showSoldOutButton = description.getAttribute('showSoldOutButton') === 'true';
        const isAvailable = description.getAttribute('data-is-available') === 'true';

        const allKlaviyoForms = document.querySelectorAll('div.klaviyo-form');
        const formId = description.getAttribute('data-variant-klaviyo-form-id');
        const form = document.querySelector(`.klaviyo-form-${formId}`);

        //const subscriptionWidget = document.getElementById('yk-subscription-widget');

        if (Number(description.getAttribute('data-variant-id')) === currentVariant.id && form) {
          allKlaviyoForms.forEach((form) => {
            form.style.display = 'none';
          });
          addToCartWrapper.style.display = 'none';
          form.style.display = 'block';

          if (fakeButton) {
            fakeButton.style.display = 'none';
          }
          break;
        } else if (
          Number(description.getAttribute('data-variant-id')) === currentVariant.id &&
          (showSoldOutButton || !isAvailable)
        ) {
          addToCartWrapper.style.display = 'none';

          allKlaviyoForms.forEach((form) => {
            form.style.display = 'none';
          });

          // if (subscriptionWidget) {
          //   subscriptionWidget.style.display = 'none';
          // }

          if (fakeButton) {
            fakeButton.style.display = 'block';
          } else {
            addToCartWrapper.insertAdjacentHTML(
              'beforebegin',
              '<button disabled class="btn btn--primary-2 fake-soldout-button w-full mt-5">WYPRZEDANY</button>'
            );
          }

          break;
        } else {
          addToCartWrapper.style.display = 'flex';

          // if (subscriptionWidget) {
          //   subscriptionWidget.style.display = 'block';
          // }

          allKlaviyoForms.forEach((form) => {
            form.style.display = 'none';
          });

          if (fakeButton) {
            fakeButton.style.display = 'none';
          }
        }
      }
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (e) => e.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    document.querySelectorAll('.product-gallery')?.forEach((swiperElement) => {
      const firstSlide = swiperElement.querySelector('.product-image');
      const image = firstSlide.querySelector(`[data-variant-media-id="${this.currentVariant.featured_media.id}"]`);
      firstSlide.prepend(image);

      swiperElement?.swiper?.slideTo(0, 0, !0);
    });
  }
  updateFastBuyGallery(currentVariant) {
    const slides = document.querySelectorAll('#quick-buy-product-gallery .product-image.swiper-slide');
    if (slides.length) {
      slides.forEach((slide) => {
        const slideVariantId = slide.getAttribute('data-variant-id');
        if (slideVariantId === currentVariant.id.toString()) {
          slide.style.display = 'block';
        } else {
          slide.style.display = 'none';
        }
      });
    }
  }
  updateURL() {
    if (this.quickBuyEnabled) return;
    this.currentVariant &&
      'false' !== this.dataset.updateUrl &&
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const e = document.getElementById(`Share-${this.dataset.section}`);
    e && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
      const t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id), t.dispatchEvent(new Event('change', { bubbles: !0 }));
    });
  }
  updatePickupAvailability() {
    const e = document.querySelector('pickup-availability');
    e &&
      (this.currentVariant && this.currentVariant?.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute('available'), (e.innerHTML = '')));
  }
  removeErrorMessage() {
    const e = this.closest('section');
    if (!e) return;
    const t = e.querySelector('product-form');
    t && t.handleErrorMessage();
  }

  handleOnetimesAddToCartButtonPriceChange() {
    setTimeout(() => {
      const totalPriceOnButton = document.querySelectorAll('.totalPriceOnButton');

      const quantityInput = document.querySelector('.quantity__input');
      const price = (this.currentVariant.price / 100).toFixed(2);

      let totalPrice = (price * quantityInput.value).toFixed(2);

      totalPriceOnButton[0].innerHTML = totalPrice.replace('.', ',') + ' ZŁ';
      totalPriceOnButton[1].innerHTML = totalPrice.replace('.', ',') + ' ZŁ';
    }, 150);
  }

  handleCustomWidgetPriceChange(currentVariant) {
    setTimeout(() => {
      const widget = document.getElementById('yk-subscription-widget');
      if (!widget) return;

      const subPriceEl = widget.querySelector('.sub-wrapper .yk-radio__price');
      const onetimePriceEl = widget.querySelector('.one-time-wrapper .yk-radio__price');
      const subWrapper = document.getElementById('yk-subscription-wrapper');
      const quantityInput = document.querySelector('.quantity__input');
      const button_add_to_cart = document.querySelectorAll('.totalPriceOnButton');

      const variantDescritpion = document.querySelectorAll('.variant__description');
      const crossedOutPriceSub = widget.querySelector('.sub-wrapper .crossed-out-price');
      const crossedOutPriceOnetime = widget.querySelector('.one-time-wrapper .crossed-out-price');

      let matched = false;

      for (let i = 0; i < variantDescritpion.length; i++) {
        const description = variantDescritpion[i];
        const variantId = Number(description.getAttribute('data-variant-id'));

        if (variantId === currentVariant.id && description.style.display === 'block') {
          const compareAtPrice = description.getAttribute('compareatprice');

          if (compareAtPrice !== '') {
            crossedOutPriceOnetime.textContent = compareAtPrice;
            crossedOutPriceOnetime.style.display = 'block';

            crossedOutPriceSub.textContent = quickModalCountCompareAtPrice(compareAtPrice);
            crossedOutPriceSub.style.display = 'block';
          } else {
            crossedOutPriceOnetime.textContent = '';
            crossedOutPriceOnetime.style.display = 'none';

            crossedOutPriceSub.textContent = '';
            crossedOutPriceSub.style.display = 'none';
          }

          matched = true;
          break;
        }
      }

      if (!matched) {
        crossedOutPriceOnetime.textContent = '';
        crossedOutPriceOnetime.style.display = 'none';

        crossedOutPriceSub.textContent = '';
        crossedOutPriceSub.style.display = 'none';
      }

      if (widget) {
        const price = this.currentVariant.price / 100;
        const totalPrice = (price * quantityInput.value).toFixed(2);
        const totalPriceFormatted = totalPrice.replace('.', ',') + ' ZŁ';

        const subPrice = (price * 0.85).toFixed(2);
        const subPriceFormatted = subPrice.replace('.', ',') + ' ZŁ';

        if (onetimePriceEl) onetimePriceEl.innerText = price.toFixed(2).replace('.', ',') + ' ZŁ';
        if (subPriceEl) subPriceEl.innerText = subPriceFormatted;

        if (subWrapper && subWrapper.classList.contains('active')) {
          const subTotalPrice = (subPrice * quantityInput.value).toFixed(2);
          const subTotalPriceFormatted = subTotalPrice.replace('.', ',') + ' ZŁ';
          button_add_to_cart[0].innerHTML = subTotalPriceFormatted;
          button_add_to_cart[1].innerHTML = subTotalPriceFormatted;
        } else {
          button_add_to_cart[0].innerHTML = totalPriceFormatted;
          button_add_to_cart[1].innerHTML = totalPriceFormatted;
        }
      }
    }, 151);
  }

  renderProductInfo() {
    const variant = this.currentVariant;
    fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `price-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html'),
          s = document.getElementById(t),
          n = i.getElementById(t);
        if (n && s) {
          s.innerHTML = n.innerHTML;
          if (typeof window.initializeLowestPriceFrom30Days === 'function') {
            window.initializeLowestPriceFrom30Days(s);
          }
          s.querySelectorAll(LOWEST_PRICE_WRAPPER_SELECTOR).forEach((wrapper) => {
            showLowestPriceForVariantInWrapper(wrapper, variant.id);
          });
          if (typeof window.updateResponsiveAddToCartLabels === 'function') {
            window.updateResponsiveAddToCartLabels();
          }
        }
        const r = document.getElementById(`price-${this.dataset.section}`);
        r && r.classList.remove('visibility-hidden'),
          this.toggleAddButton(!variant?.available, window.variantStrings.soldOut);
      })
      .then((() => this.dispatchChangeVariantEvent()).bind(this));
  }
  toggleAddButton(isDisabled = true, message) {
    // Lista ID variantów, które mają włączony bundle-box
    const tamponsOwnConfigVariantsIDs = [40622276837428, 40493254672436];
    const form = document.getElementById(`product-form-${this.dataset.section}`);

    if (!form || tamponsOwnConfigVariantsIDs.includes(this.currentVariant?.id)) return;

    const widgetButton = document.getElementById('widget-add-to-sub-trigger');
    const button = form.querySelector('[name="add"]');
    const contentMessage = form.querySelector('[name="add"] > span');

    if (button) {
      if (isDisabled) {
        button.setAttribute('disabled', 'disabled');
        if (message && contentMessage) {
          contentMessage.textContent = message;
        }
      } else {
        button.removeAttribute('disabled');
        if (button.dataset.labelMobile || button.dataset.labelDesktop) {
          setAddToCartButtonLabel(button);
        } else if (contentMessage) {
          contentMessage.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (widgetButton) {
      if (isDisabled) {
        widgetButton.setAttribute('disabled', 'disabled');
      } else {
        widgetButton.removeAttribute('disabled');
      }
    }
  }
  setUnavailable() {
    const e = document.getElementById(`product-form-${this.dataset.section}`),
      t = e.querySelector('[name="add"]'),
      i = e.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`);
    t && ((i.textContent = window.variantStrings.unavailable), s && s.classList.add('visibility-hidden'));
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const e = Array.from(this.querySelectorAll('fieldset'));
    this.options = e.map((e) => Array.from(e.querySelectorAll('input')).find((e) => e.checked).value);
  }
}
customElements.define('variant-radios', VariantRadios);

const firstStepGiftContainer = document.querySelectorAll('#qa-section-verification-code-prompt .qa-margin-bottom');
const firstStetGiftButton = document.querySelector('#qa-section-verification-code-prompt .qa-button');

if (firstStepGiftContainer && firstStepGiftContainer[1]) {
  const text = firstStepGiftContainer[1].textContent;
  const modifiedText = text.replace(/(jednorazowo|szt\.) /g, '$&<br>');

  firstStepGiftContainer[1].innerHTML = modifiedText;
}

secondStetGiftButton = document.querySelector('#qa-section-verification-code-input .qa-button');

if (firstStetGiftButton) {
  firstStetGiftButton.addEventListener('click', () => {
    const secondStepGiftTitle = document.querySelector('#qa-section-verification-code-input h2.qa-margin-bottom');
    const secondStepGiftContainer = document.querySelectorAll('#qa-section-verification-code-input .qa-margin-bottom');
    const secondStepGiftLink = document.querySelector('#qa-section-verification-code-input a');
    // secondStetGiftButton = document.querySelector('#qa-section-verification-code-input .qa-button')

    if (secondStepGiftTitle && secondStepGiftContainer[1]) {
      secondStepGiftTitle.textContent = 'Wprowadź szcześciocyfrowy kod';
    }

    if (secondStepGiftContainer[1]) {
      const text = secondStepGiftContainer[1].textContent;
      const modifiedText = text.replace(/(jednorazowo|szt\.) /g, '$&<br>');

      secondStepGiftContainer[1].innerHTML = modifiedText;
    }

    if (secondStepGiftLink) {
      const linkText = secondStepGiftLink.textContent;
      const modifiedText = linkText.replace('Spróbuj ponownie', '<u>Spróbuj ponownie</u>');
      secondStepGiftLink.innerHTML = modifiedText;
    }
  });
}

if (secondStetGiftButton) {
  secondStetGiftButton.addEventListener('click', () => {
    const thirdStepGiftTitle = document.querySelector('#qa-section-message h2.qa-margin-bottom');
    const intervalLast = setInterval(() => {
      if (thirdStepGiftTitle.textContent == 'Success') {
        thirdStepGiftTitle.textContent = 'Gotowe';
        clearInterval(intervalLast);
      }
    }, 100);
  });
}

let elements = document.querySelectorAll('.shopify-policy__title');
if (elements) {
  elements.forEach(function (element) {
    if (element.textContent.includes('Warunki świadczenia usług')) {
      element.style.display = 'none';
    }
  });
}

const handleNumeralWords = (words, value) => {
  if (value === 1) {
    return words[0];
  } else if (value % 100 > 10 && value % 100 < 21) {
    return words[2];
  } else if (value % 10 <= 4 && value % 10 > 1) {
    return words[1];
  } else {
    return words[2];
  }
};

const getSubscriptionDiscountValue = () => {
  let discountPercent = 0.15;
  if (subscriptionWidgetLabel) {
    const regex = /(\d+)%/;
    const match = subscriptionWidgetLabel.match(regex);
    discountPercent = Number(match[1]) * 0.01;
  }
  return discountPercent;
};

const buyButtonTooltipObserver = () => {
  const elements = document.querySelectorAll('[data-tooltip-content]');

  const createTooltip = (element) => {
    if (!element.querySelector('.custom-tooltip')) {
      const content = element.getAttribute('data-tooltip-content');
      const tooltip = document.createElement('div');
      tooltip.innerText = content;
      tooltip.classList.add('custom-tooltip');
      element.appendChild(tooltip);
    }
  };

  const deleteTooltip = (element) => {
    element.querySelector('.custom-tooltip').remove();
  };

  const callback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-tooltip-content') {
        if (mutation.target.getAttribute('data-tooltip-content')) {
          createTooltip(mutation.target);
        } else {
          deleteTooltip(mutation.target);
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  elements.forEach((btn) => observer.observe(btn, { attributes: true }));
};

document.addEventListener('DOMContentLoaded', buyButtonTooltipObserver);

// TODO opanowanować te przecinki i wywalić observer
const buyButtonCurrencySeparatorObserver = () => {
  const items = document.querySelectorAll('.totalPriceOnButton');

  const updateCurrencySeparator = (mutationsList) => {
    for (let mutation of mutationsList) {
      mutation.addedNodes.forEach((addedNode) => {
        if (addedNode.data.includes('.')) {
          mutation.target.innerHTML = mutation.target.innerHTML.replace('.', ',');
        }
      });
    }
  };

  const observer = new MutationObserver(updateCurrencySeparator);
  items.forEach((item) => observer.observe(item, { childList: true, subtree: true }));
};

document.addEventListener('DOMContentLoaded', buyButtonCurrencySeparatorObserver);

const addCustomerToLoyaltyProgram = async (user) => {
  const webhook = 'https://hook.eu1.make.com/ykq4hjwbty4otuhmh9jg3ii01med8oi5';

  if (!user) {
    throw new Error('No user data provided!');
  }

  const options = {
    method: 'POST',
    body: JSON.stringify({ customer: user }),
    headers: {
      guid: '59l09EDw5MHhrkRsGzo6sQ',
      'x-api-key': 'TNhdGDdqQhF4AMXdbsqrQgtt',
      'content-type': 'application/json',
      accept: 'application/json',
    },
  };

  try {
    await fetch(webhook, options);
  } catch (err) {
    console.error('Error! ', err);
  }
};

const dataLayerPromise = (data, timeoutMs = 950) => {
  return new Promise((resolve) => {
    let settled = false;

    const done = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve();
    };

    const timer = setTimeout(done, timeoutMs);

    try {
      const dl = window.dataLayer;
      if (!dl || typeof dl.push !== 'function') return done();

      dl.push({
        shopify_theme_name: Shopify?.theme?.name,
        shopify_theme_id: Shopify?.theme?.id,
        device_type: typeof deviceType !== 'undefined' ? deviceType : '',
        location: window.location?.href || '',
        user_id: window.customerData?.id || '',
        ...data,
        eventCallback: done,
      });
    } catch {
      done();
    }
  });
};

const continueLinkClickEvent = (e, url) => {
  if (e.ctrlKey || e.metaKey || e.which === 2) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noreferrer';
    a.click();
  } else {
    window.location.href = url;
  }
};

const isUrlNotAllowedToDisplayOn = () => {
  const params = JSON.parse(document.querySelector('.newsletter-params')?.innerHTML ?? '');

  if (Array.isArray(params) && params?.length > 0) {
    const search = new URLSearchParams(window.location.search);
    let isMatched = false;

    params.forEach(({ key, value }) => {
      if (search.get(key) === value) {
        isMatched = true;
      }
    });

    return isMatched;
  }

  return false;
};
